import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  @media (max-width: 768px) {
  }

  @media (min-width: 1024px) {
    background-color: var(--main-color);
  }
`

export const Grid = styled.div`
  background: #1a1a1a;
  border-radius: 35px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  max-width: 50%;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 100px;
  @media (min-width: 200px) and (max-width: 768px) {
    flex-direction: column;
    width: 95%;
  }
`

export const HeadWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
`

export const SHead = styled.header`
  margin-bottom: 1.45rem;
  h1 {
    font-family: var(--main-font);
  }
  @media (min-width: 200px) and (max-width: 768px) {
    h1 {
      font-size: 1rem;
      padding-top: 5px;
    }
  }
  @media (min-width: 768px) and (max-width: 1000px) {
    h1 {
      font-size: 1rem;
      padding-top: 5px;
    }
  }
  @media (min-width: 1001px) {
    h1 {
      font-size: 1rem;
      padding-top: 5px;
    }
  }
  /* ----------- iPhone 6, 6S, 7 and 8 ----------- */

  /* Portrait and Landscape */
  @media only screen /* //and (min-device-width: 375px) //and (max-device-width: 667px) */ and (min-device-width: 300px) and (max-device-width: 1000px) and (-webkit-min-device-pixel-ratio: 2) {
    h1 {
      font-size: 2rem;
      padding-top: 5px;
    }
  }
`

export const Content = styled.div`
  padding: 5px 20px 5px 30px;
  width: 95%;
`

// IMAGE & TITLE layout

export const ImgCont = styled.div`
  display: flex;
  justify-content: center;
  // background: hotpink;
  position: relative;
  display: flex;
  width: 100%;
  @media (min-width: 200px) and (max-width: 768px) {
    flex-direction: column;
  }
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    width: 100%;
  }
`

export const BlogHeader = styled.div`
  display: flex;
  margin-bottom: 50px;
  // border: 10px dashed white;
  @media (min-width: 200px) and (max-width: 768px) {
    flex-direction: column;
  }
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    flex-direction: column;
  }
`

export const BlogImgCont = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  display: flex;
  width: 40%;
  border: 3px solid white;
  @media (min-width: 200px) and (max-width: 768px) {
    width: 100%;
  }
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    width: 100%;
  }
`

export const ImgDescript = styled.p`
  color: grey;
  font-style: italic;
  width: 100%;
  text-align: center;
  padding: 5px 10px;
  @media (min-width: 200px) and (max-width: 768px) {
    width: 100%;
  }
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    width: 100%;
  }
`

export const Image = styled(GatsbyImage)`
  width: 100%;
  object-fit: contain;
  background-position: center center;
  margin: 0 auto;
  border-radius: 8px;

  @media (min-width: 768px) and (max-width: 1268px) {
    max-height: 65vh;
    max-width: 60vw;
  }
  @media (min-width: 1269px) and (max-width: 1520px) {
    max-height: 50vh;
    max-width: 35vw;
  }
  @media (min-width: 1521px) and (max-width: 1920px) {
    max-height: 60vh;
    max-width: 23vw;
  }
`

export const ImgWrap = styled.div`
  //display: flex;
  //border: 1px solid purple;
  padding: 20px;
  width: 35%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    border-radius: 25px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  border-radius: 25px;
  overflow: hidden; // no padding otherwise border radius does not work
  @media (min-width: 200px) and (max-width: 768px) {
    min-width: 200px;
    max-width: 100%;
    max-height: 80vh;
    padding: 0%;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    min-width: 100%;
    max-height: 80vh;
    padding: 0%;
  }
  @media (min-width: 768px) and (max-width: 1280px) {
    min-width: 200px;
    max-width: 100%; //height: 70vh;
  }
  @media (min-width: 1281px) and (max-width: 1920px) {
    min-width: 250px;
  }
`

export const TitleWrap = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  // height: auto;
  // border: 3px dashed white;
  min-width: 60%;
  max-width: max-content;

  @media (max-width: 768px) {
    width: 100%;
  }
  @media (min-width: 768px) and (max-width: 1268px) {
  }
  @media (min-width: 1269px) {
  }
`

export const Title = styled.h1`
  z-index: 10;
  font-size: clamp(2rem, 2.5vw, 2.5rem) !important;
  font-weight: 700;
  color: #fff;
  text-shadow: 2px 2px black;
  stroke: black;
  text-align: center;
  padding: 10px;

  /* @media (min-width: 200px) and (max-width: 800px) {
    font-size: 5.2vw;
  }
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    font-size: 5.2vw;
  }
  @media (min-width: 801px) and (max-width: 1268px) {
    font-size: 4.6vw;
  }
  @media (min-width: 801px) and (max-width: 1268px) {
    font-size: 3vw;
  }
  @media (min-width: 1269px) and (max-width: 1920px) {
    width: 40vw;
  } */
`

// Other Title Stylings

export const HeadingTwo = styled.h2`
  z-index: 10;
  font-size: 1.5rem;
  font-weight: 800;
  color: white;
  text-shadow: 3px 3px var(--main-color);
  @media (min-width: 200px) and (max-width: 768px) {
    font-size: 1rem;
    word-wrap: break-word;
  }
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    font-size: 1rem;
    word-wrap: break-word;
  }
`

// OL & UL

export const ArticleOL = styled.ol`
  color: var(--text-gray);
  width: 50%;
  padding: 5% 5% 6% 6%;
  margin: 0 auto;
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    width: 80%;
  }
`
export const ArticleUL = styled.ul`
  padding: 5% 5% 8% 8%;
  color: var(--text-gray);
  width: 50%;
  margin: 0 auto;
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    width: 80%;
  }
`

// Styled A
export const RichLink = styled.a`
  color: goldenrod;
`

// Div style

export const ArticleStyle = styled.div`
  font-size: 1rem;
  margin-bottom: 10px;
  line-height: 1.6rem;
`

// InfoComponent

export const InfoComponent = styled.div`
  display: flex;
  margin: 10px;
  padding: 10px 6vw;
  font-size: 0.8rem;
  letter-spacing: 0.5px;
`

export const ColCont = styled.div`
  display: flex;
  justify-content: center;
`

export const Col1 = styled.div`
  display: flex;
  flex-direction: column;
`

export const Col2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
`

export const DatePub = styled.div`
  display: flex;
  justify-content: center;
  padding-left: 15px;
  font-size: 0.8em;
  color: var(--text-gray);
`

export const Author = styled.div`
  padding-left: 15px;
  display: flex;
  font-size: 0.8em;
  color: var(--text-gray);
`

export const Category = styled.div`
  padding-left: 15px;
  display: flex;
  font-size: 0.8em;
  color: var(--text-gray);
`

// End TopComponent

export const QuoteBlock = styled.div`
  display: block;
  padding-left: 25px;
  border-left: 5px solid brown;
  font-style: italic;
`
